import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import NatCurrentDateTimeRepo from '../../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatResidentWindowFilmAttachConfirm from './resident/NatResidentWindowFilmAttachConfirm'
import {
    NatResidentWindowFilmAttachInfo,
    NatResidentWindowFilmAttachLocationState,
} from './NatResidentApplicationInterface'
import {NatPutWindowFilmAttachRequest, NatPutWindowFilmAttachResponse} from '../repository/NatPutWindowFilmAttach'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<NatResidentWindowFilmAttachLocationState>
}

class NatResidentWindowFilmAttachConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatResidentWindowFilmAttachInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName,
            applicantFirstName,
            windowFilmAttachDate,
            contractorRequest,
            contractorName,
            contractorZipCode,
            contractorPrefecture,
            contractorAddress2,
            contractorAddress3,
            contractorBuildingRoomNumber,
            contractorPhoneNumber,
            contractorRep,
            applyToAttachment,
        } = locationState

        const copyFileNumbers: number[] = applyToAttachment
            .map(attachment => attachment.fileNumber)
            .filter((fileNumber): fileNumber is Exclude<typeof fileNumber, undefined> => fileNumber !== undefined)
            .filter((fileNumber): fileNumber is Exclude<typeof fileNumber, null> => fileNumber !== null)

        const request: NatPutWindowFilmAttachRequest = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            windowFilmAttachDate: windowFilmAttachDate,
            contractorRequest: contractorRequest,
            contractorName: contractorName,
            contractorZipCode: contractorZipCode,
            contractorPrefecture: contractorPrefecture,
            contractorAddress2: contractorAddress2,
            contractorAddress3: contractorAddress3,
            contractorBuildingRoomNumber: contractorBuildingRoomNumber,
            contractorPhoneNumber: contractorPhoneNumber,
            contractorRep: contractorRep,
            reApplyCopyFileNumbers: copyFileNumbers,
            confirmed: true,
        }

        if (!request) {
            return
        }

        try {
            const response: Nullable<NatPutWindowFilmAttachResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyWindowFilmAttach.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentWindowFilmAttachLocationState = this.props.location.state
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/windowFilmAttaches/input`,
            {
                replace: true,
                state: JSON.parse(JSON.stringify(locationState)),
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentWindowFilmAttachConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>
                    修正する
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentWindowFilmAttachConfirmPage)
